import { createRouter, createWebHashHistory } from 'vue-router'
import { routerBasePath } from '@/config/deployBase'
import landing from '../views/landingPage.vue'
import NewJourney from '../views/newJourney.vue'
import FormWizard from '@/views/formWizard.vue'
import MultipleQuotes from "@/views/multipleQuotes.vue"
import ProcessWizard from "@/views/processWizard.vue"
import SingleQuote from '@/views/SingleQuote.vue'
import confirmPay from "@/views/confirmPay.vue"
import confirmPayDiy from "@/views/confirmPayDiy.vue"
import VehicleQuote from '@/views/vehicleQuote.vue'
import CompleteThankyou from '@/views/rmThankYou.vue'
import KycForm from "@/views/kycForm.vue"
import OvdsUpload from '@/views/OvdsUpload.vue'
import kycSuccess from '@/views/kycSuccess.vue'
import KycFailed from '@/views/KycFailed.vue'
import errorPage from '@/views/errorPage.vue'
import dashboard from '@/views/dashboard.vue'
import PaymentOutcomeLegacyRedirect from '@/views/PaymentOutcomeLegacyRedirect.vue'
import FileUploadView from '../views/FileUploadView.vue'
import PaymentStatusView from '../views/PaymentStatusView.vue'
import ProposalSubmissionView from '../views/ProposalSubmissionView.vue'
import readOnlyProposalDetails from '@/views/read-only-proposal-details.vue'
import SPManagementView from '@/views/SPManagementVue.vue'
import Login from '@/views/login.vue'
import { registerAppRoutesForRoleAccess, runRoleRestrictedRouteGuard } from '@/config/roleRouteAccess'

export const appRoutes = [
    {
      path: '/',
      name: 'Landing-page',
      component: landing,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },

    {
      path:"/payment",
      name:"PaymentSuccess",
      component: PaymentOutcomeLegacyRedirect
    },
    {
      path:"/payment-status",
      name:"PaymentStatus",
      component:PaymentStatusView
    },
    {
      path:"/proposal-submission",
      name:"ProposalSubmission",
      component: ProposalSubmissionView
    },
    {
      path:"/inspection",
      name:"inspection",
      component: PaymentOutcomeLegacyRedirect
    },
    {
      path:"/pending",
      name:"paymentPending",
      component: PaymentOutcomeLegacyRedirect
    },
    {
      path: '/New-Journey',
      name: 'New-Journey',
      component: NewJourney,
    },
    {
      path: '/form-Wizard',
      name: 'formWizard',
      component: FormWizard,
    }, 
   
    {
      path: '/policy-quote',
      name: 'MultipleQuotes',
      component: MultipleQuotes,
    }, 
    {
      path:"/process-wizard",
      name:"ProcessWizard",
      component: ProcessWizard,
    },
    {
      path:"/vehicle-quote",
      name:"VehicleQuote",
      component:VehicleQuote
    },
    {
      path:"/policy-details",
      name:"singleQuote",
      component: SingleQuote,
     },
     {
      path:"/dashboard",
      name:"dashboard",
      component: dashboard,
     },
    {
      path:"/error-page",
      name:"errorPage",
      component: errorPage,
    },
    {
      path:"/confirm-payment",
      name:"confirmPay",
      component:confirmPay
    },
    {
      path:"/confirm-payment-diy",
      name:"confirmPayDiy",
      component:confirmPayDiy
    },
    {
      path:"/Thank-you-RM",
      name:"completeThankyou",
      component:CompleteThankyou
    },
    {
      path:"/ckyc-form",
      name:"KycForm",
      component:KycForm
    },
    {
      path:"/upload-ovds",
      name:"OvdsUpload",
      component:OvdsUpload
    },
    {
      path:"/kyc-success",
      name:"kycSuccess",
      component:kycSuccess
    },
    {
      path:"/kyc-Failed",
      name:"KycFailed",
      component:KycFailed
    },
    {
      path: '/fileUpload',
      name: 'file-upload',
      component: FileUploadView,
    },
    {
      path:"/paymentfailed",
      name:"PaymentFailed",
      component: PaymentOutcomeLegacyRedirect
    },
    {
      path:"/read-only-proposal-details",
      name:"readOnlyProposalDetails",
      component:readOnlyProposalDetails
    },
    {
      path: '/sp-management',
      name: 'sp-management',
      component: SPManagementView,
    },
    

]

registerAppRoutesForRoleAccess(appRoutes)

const router = createRouter({
    history: createWebHashHistory(routerBasePath),
    routes: appRoutes,
    // scrollBehavior(to, from, savedPosition) { 
    //   // always scroll to top
    //   return { top: 0 }
    // }
  })


router.beforeEach((to, from, next) => {
  runRoleRestrictedRouteGuard(to, from, next)
})

router.beforeEach((to, from, next) => {
  const routesNames = ['PaymentSuccess', 'PaymentStatus', 'ProposalSubmission', 'inspection', 'paymentPending', 'completeThankyou', 'PaymentFailed', 'ProcessWizard', 'sp-management'];
  if (routesNames.includes(to.name)) {
    window.addEventListener('beforeunload', handleBeforeUnload);
  } else {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  }
  next();
});

const handleBeforeUnload = (event) => {
  event.preventDefault();
  event.returnValue = '';
};

  export default router